import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Pagination from 'components/Pagination';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style,
  individual_icon_header_style_callback
} from '../../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import ProposalService from '../service';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { useForm } from 'react-hook-form';
import ErrorModal from 'components/Modal/ErrorModal/ErrorModal';

const ProposalList = () => {
  const history = useHistory();

  const [proposalInfo, setProposalInfo] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showDisabled, setShowDisable] = useState(false);
  const [errorDetails, setErrorDetails] = useState({
    message: '',
    campaign: [],
    timeout: [],
    flexias: [],
    channels: []
  });
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const { watch } = useForm();

  const handleGetProposal = (selectedPage = 1, search = '') => {
    setLoading(true);

    ProposalService.getAllProposals(selectedPage, 10, search, {
      showDisable: showDisabled
    })
      .then((response) => {
        setProposalInfo(
          Array.isArray(response.data)
            ? response.data
            : response.data.data || []
        );
        setQuantity(response.totalRegisters || response.data.count || 0);
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar configurações da Proposta!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    handleGetProposal();
  }, []);

  useEffect(() => {
    handleGetProposal();
    setActivePage(1);
  }, [showDisabled]);

  const getProposalSearch = (event) => {
    handleGetProposal(1, event.target.value);
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    handleGetProposal(page);
  };

  const toggleDisable = (id, status) => {
    setLoading(true);
    const showDisableActual = showDisabled;
    const newStatus = !status;

    ProposalService.enableProposalById(id, newStatus)
      .then((res) => {
        if (res.data.message) {
          if (!showDisableActual && newStatus === false) {
            setProposalInfo((prevProposals) =>
              prevProposals.filter((proposal) => proposal.id !== id)
            );
          } else {
            setProposalInfo((prevProposals) =>
              prevProposals.map((proposal) =>
                proposal.id === id
                  ? { ...proposal, active: newStatus }
                  : proposal
              )
            );
          }
          const message = newStatus ? 'Habilitada' : 'Desabilitada';
          toast.success(
            `Alteração realizada com sucesso, proposta agora está ${message}`,
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Erro ao alterar status da Proposta ', {
          autoClose: 3000,
          closeOnClick: true
        });
        if (err?.response?.data.usageFlexia) {
          setErrorDetails({
            message: err.response.data.msg,
            campaign: err.response.data.usageFlexia.campaign,
            timeout: err.response.data.usageFlexia.timeout,
            flexias: err.response.data.usageFlexia.flexias,
            channels: err.response.data.usageFlexia.channels
          });
          setErrorModalOpen(true);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/crm/proposal/form"
        name="Form validation"
        parentName="Forms"
      />

      <ErrorModal
        isOpen={errorModalOpen}
        toggle={() => setErrorModalOpen(false)}
        message={errorDetails.message}
        entityName="Proposta"
      />

      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Propostas</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Pesquisar por nome"
                          type="text"
                          onChange={(event) => getProposalSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2 mt-md-1">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisabled}
                            onChange={() => setShowDisable(!showDisabled)}
                          />
                          <span>Mostrar desabilitados</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={proposalInfo || []}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'title',
                      text: 'Título',
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'active',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style_callback,
                      text: 'Desabilitar / Habilitar',
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={row.active}
                            id={row.id}
                            onChange={() => toggleDisable(row.id, row.active)}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            disabled={!row.active}
                            onClick={() =>
                              history.push(`/admin/crm/proposal/form/${row.id}`)
                            }
                          >
                            <li className="fas fa-edit"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProposalList;
